import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';

const styles = theme => ({
  checked: {
    color: theme.palette.primary['A700'],
  },
});

const CheckboxesWidget = props => {
  const {
    // classes,
    // //id,
    // value,
    // required,
    // disabled,
    // readonly,
    // label,
    // autofocus,
    // onChange,

    classes,
    formContext,
    options,
    value,
    required,
    disabled,
    readonly,
    autofocus,
  } = props;
  const {enumOptions} = options
  const signed = formContext && formContext.signedAt && formContext.signedAt !== undefined

  const _onChange = (selectedValue) => {
    const {value, onChange} = props;

    if (value.indexOf(selectedValue)<0) {
      value.push(selectedValue); 
      onChange(value);

    } else if (value.indexOf(selectedValue)>-1) {
      const index = value.indexOf(selectedValue)
      value.splice(index, 1)
      onChange(value);
    }
  };
  return (

    <FormControl disabled={disabled || formContext.formStatus !== 'editable'}>
      {console.log('value',value)}
      {enumOptions.map((option, i) => {
          return (
            <FormControlLabel
              key={i}
              control={
                <Checkbox
                  //id={id}
                  checked={value.indexOf(option.value)<0 ? false : true}
                  required={required}
                  disabled={signed || disabled || readonly}
                  autoFocus={autofocus}
                  classes={{
                    checked: classes.checked,
                  }}
                  onChange={event => _onChange(option.value)}
                />
              }
              label={option.label}
            />
          );
        })}
    </FormControl>
  );
};

CheckboxesWidget.defaultProps = {
  autofocus: false,
};

CheckboxesWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  //id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.array,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
};

export default withStyles(styles)(CheckboxesWidget);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/CheckboxesWidget.js